import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=5e6fb66a&scoped=true&"
import script from "./UserGrid.vue?vue&type=script&lang=js&"
export * from "./UserGrid.vue?vue&type=script&lang=js&"
import style0 from "./UserGrid.vue?vue&type=style&index=0&id=5e6fb66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6fb66a",
  null
  
)

export default component.exports